/**
 * 客户端ListType
 *
 * @export
 * @enum {number}
 */
export var AppDocsListType;
(function (AppDocsListType) {
    AppDocsListType[AppDocsListType["listTypeOffline"] = -1] = "listTypeOffline";
    AppDocsListType[AppDocsListType["listTypeAll"] = 1] = "listTypeAll";
    AppDocsListType[AppDocsListType["listTypeCreated"] = 2] = "listTypeCreated";
    AppDocsListType[AppDocsListType["listTypeTrash"] = 3] = "listTypeTrash";
    AppDocsListType[AppDocsListType["listTypeShared"] = 4] = "listTypeShared";
    AppDocsListType[AppDocsListType["listTypeMyDoc"] = 5] = "listTypeMyDoc";
    AppDocsListType[AppDocsListType["listTypeRecent"] = 6] = "listTypeRecent";
    AppDocsListType[AppDocsListType["listTypeStared"] = 7] = "listTypeStared";
    AppDocsListType[AppDocsListType["listTypeInSharedFolder"] = 9] = "listTypeInSharedFolder";
})(AppDocsListType || (AppDocsListType = {}));
//# sourceMappingURL=DocListType.js.map